import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItineraryItem } from './itinerary.model';

@Injectable({ providedIn: 'root' })
export class ItineraryService {
  private injector = inject(EnvironmentInjector);

  constructor(private db: AngularFireDatabase) {}

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getItems(): Observable<ItineraryItem[]> {
    return this.inCtx(() => this.db.list<ItineraryItem>('itinerary/items').snapshotChanges().pipe(
      map(actions => actions.map(a => ({
        id: a.key,
        ...(a.payload.val() as ItineraryItem)
      })))
    ));
  }

  addItem(item: ItineraryItem): Promise<void> {
    return this.inCtx(() => this.db.object(`itinerary/items/${item.id}`).set(item));
  }

  updateItem(item: ItineraryItem): Promise<void> {
    return this.inCtx(() => this.db.object(`itinerary/items/${item.id}`).set(item));
  }

  deleteItem(id: string): Promise<void> {
    return this.inCtx(() => this.db.object(`itinerary/items/${id}`).remove());
  }
}
